// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import store from './store'
import VueResource from 'vue-resource'
import titleMixin from './mixin/titleMixin'
import descriptionMixin from './mixin/descriptionMixin'
import genericMixin from './mixin/genericMixin'
import canonicalMixin from './mixin/canonicalMixin'

Vue.mixin(titleMixin)
Vue.mixin(descriptionMixin)
Vue.mixin(genericMixin)
Vue.mixin(canonicalMixin)
Vue.use(BootstrapVue)
Vue.use(VueResource)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#booking-ref-app',
  router,
  store,
  data: {
    brand: document.getElementById('booking-ref-app').dataset.brand,
    country: document.getElementById('booking-ref-app').dataset.country,
    locale: document.getElementById('booking-ref-app').dataset.locale,
    type: document.getElementById('booking-ref-app').dataset.type,
    language: document.getElementById('booking-ref-app').dataset.language,
    platform: document.getElementById('booking-ref-app').dataset.platform,
    cssBrand: document.getElementById('booking-ref-app').hasAttribute('data-version') && document.getElementById('booking-ref-app').getAttribute('data-version') === '2020' ? 'wp-2020' : document.getElementById('booking-ref-app').dataset.brand,
    homeTitle: document.getElementById('booking-ref-app').dataset.homeTitle
  },
  created () {
    this.$store.commit('saveConfig', {
      'brand': this.brand,
      'country': this.country,
      'i18n': require(`./i18n/${this.locale}`),
      'locale': this.locale,
      'type': this.type,
      'cssBrand': this.cssBrand,
      'language': this.language ? this.language : this.locale.substring(0, 2),
      'platform': this.platform,
      'homeTitle': this.homeTitle
      // 'settings': settings[this.brand][this.locale]
    })
  },
  mounted: function () {
    var v = this
    v.$nextTick(function () {
      if (document.getElementsByClassName('ci-2022').length > 0) {
        var refreshIntervalId = ''
        setInterval(function () {
          if (refreshIntervalId !== window.location.href) {
            var addReplaceColorAfterSeconds = 50
            var addReplaceColorInterval = 10
            var i = 0
            var addReplaceColorIntervalFunction = setInterval(function () {
              document.querySelectorAll('*').forEach(function (element) {
                if (window.getComputedStyle(element).color === 'rgb(25, 124, 131)' || window.getComputedStyle(element).color === 'rgb(31, 162, 172)') {
                  element.style.color = 'rgb(0, 125, 105)'
                }
                if (window.getComputedStyle(element).backgroundColor === 'rgb(25, 124, 131)' || window.getComputedStyle(element).backgroundColor === 'rgb(31, 162, 172)') {
                  element.style.backgroundColor = 'rgb(0, 125, 105)'
                }
                if (window.getComputedStyle(element).background === 'rgb(25, 124, 131)' || window.getComputedStyle(element).background === 'rgb(31, 162, 172)') {
                  element.style.background = 'rgb(0, 125, 105)'
                }
                if (window.getComputedStyle(element).borderColor === 'rgb(25, 124, 131)' || window.getComputedStyle(element).borderColor === 'rgb(31, 162, 172)') {
                  element.style.borderColor = 'rgb(0, 125, 105)'
                }
              })
              i++
              if (i >= addReplaceColorAfterSeconds / addReplaceColorInterval) {
                clearInterval(addReplaceColorIntervalFunction)
              }
            }, addReplaceColorInterval)
            var addReplaceHoverBackgroundClassAfterSeconds = 2000
            var addReplaceHoverBackgroundClassInterval = 100
            var l = 0
            var addReplaceHoverBackgroundClassIntervalFunction = setInterval(function () {
              document.querySelectorAll('*').forEach(function (element) {
                if (!element.classList.contains('alreadyScanned')) {
                  element.classList.add('alreadyScanned')
                  element.addEventListener('mouseover', function () {
                    v.addReplaceHoverBackgroundClass(element)
                  })
                }
              })
              l++
              if (l >= addReplaceHoverBackgroundClassAfterSeconds / addReplaceHoverBackgroundClassInterval) {
                clearInterval(addReplaceHoverBackgroundClassIntervalFunction)
              }
            }, addReplaceHoverBackgroundClassInterval)
            setTimeout(function () {
              document.querySelectorAll('.alreadyScanned').forEach(function (element) {
                element.classList.remove('alreadyScanned')
              })
            }, +addReplaceHoverBackgroundClassAfterSeconds + addReplaceHoverBackgroundClassInterval)
            refreshIntervalId = window.location.href
          }
        }, 200)
      }
    })
  },
  methods: {
    addReplaceHoverBackgroundClass: function (element) {
      if ((window.getComputedStyle(element).backgroundColor === 'rgb(25, 124, 131)' || window.getComputedStyle(element).backgroundColor === 'rgb(31, 162, 172)') && !element.classList.contains('replaceHoverBackground')) {
        element.classList.add('replaceHoverBackground')
      }
      if ((window.getComputedStyle(element).color === 'rgb(25, 124, 131)' || window.getComputedStyle(element).color === 'rgb(31, 162, 172)') && !element.classList.contains('replaceHoverColor')) {
        element.classList.add('replaceHoverColor')
      }
    }
  },
  components: { App },
  template: '<App/>'
})
